import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-utility-management-software',
  imports: [RouterModule, FeatureHero],
  templateUrl: './utility-management-software.html',
  styleUrl: './utility-management-software.scss',
})
export class UtilityManagementSoftware {

}
